import axios from 'utils/axios';
import { buildOrgRolePayload } from 'utils/permissions-management';

export async function postUserNew(data) {
    try {
        const { orgRole, orgPermissions } = buildOrgRolePayload(data);
        const response = await axios.post(`/api/org-id/{orgId}/user/new`, {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            clinicMapping: data.clinicMapping,
            orgRole,
            orgPermissions
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function fetchUsersPermissionList() {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/users/user-permissions-list`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getUserDetail(userId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/user/${userId}/detail`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function updateUserDetail(userId, firstName, lastName) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/user/${userId}/detail`, {
            firstName,
            lastName
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// reportsToUserId: the manager's user id, or null to clear it
export async function setUserReportsTo(userId, reportsToUserId) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/user/${userId}/reports-to`, { reportsToUserId });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function changeClinicMapping(userId, clinicMapping, orgOptions) {
    try {
        const { orgRole, orgPermissions } = buildOrgRolePayload(orgOptions);
        const response = await axios.post(`/api/org-id/{orgId}/user/${userId}/access-config-mapping`, {
            clinicMapping,
            orgRole,
            orgPermissions
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function changeUserStatus(userId, disabled) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/user/${userId}/status`, {
            disabled
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function fetchActiveOrgMembersList() {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/users/organization-members-list`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}
